import { DialogContentText, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

export const QcsDialogContentText: FC<Props> = ({ className, sx, children }) => {
  return (
    <DialogContentText className={className} sx={sx}>
      {children}
    </DialogContentText>
  );
};
